import {PdfDetailedUserHeaderComponent} from "./pdfDetailedUserHeaderComponent";
import PdfHeaderRow from "../components/pdfHeaderRow";
import {Localizer} from "../../../../infrastructure/localization/localizer";
import { PdfAttestationHeaderModel } from "../models/pdfAttestationHeaderModel";

type PdfAttestationHeaderComponentProps = {
    data: PdfAttestationHeaderModel;
}

export function PdfAttestationHeaderComponent({ data }: PdfAttestationHeaderComponentProps) {
    return (
        <div className={"card shadow-none"}>
            <div className={"card-body flex-container-column flex-space"}>
                <PdfDetailedUserHeaderComponent bruger={data.bruger}/>
                <PdfHeaderRow>
                    <PdfHeaderRow.Entry
                        label={Localizer.global_maalbeskrivelse()}
                        value={data.maalbeskrivelse}
                    />
                </PdfHeaderRow>
            </div>
        </div>
    );
}
